import { Literals } from "shared/types";
import connectingIcon from "assets/images/icons/connecting.svg";

type Props = {
  message: string;
  onCancelBtnClick: () => void;
  copyTexts: Literals;
};

function ConnectingMessage(props: Props) {
  const { message, onCancelBtnClick, copyTexts } = props;
  return (
    <div className="flex w-full flex-col items-center rounded-t-3xl bg-white p-5 shadow-roundedCard">
      <div className="flex items-center justify-center gap-1">
        <img src={connectingIcon} alt="Connecting" width={32} height={32} />
        <p className="text-xs font-medium text-neutral-weak">{message}</p>
      </div>
      <button
        className="mt-4 border-none bg-transparent text-xs font-semibold text-indigo-800"
        onClick={onCancelBtnClick}
      >
        {copyTexts.cancelButtonText}
      </button>
    </div>
  );
}

export default ConnectingMessage;
